import React, { Component } from 'react';
import styled from 'styled-components';
import Switch from 'components/Switch';
import ButtonText from 'components/ButtonText';
import PropTypes from 'prop-types';
import SettingsSectionTitle from './SettingsSectionTitle';

const Container = styled.div`
  margin: 0;
`;

const InputContainer = styled.div`
  margin: 20px 0px;
  min-width: 0;
  @media (max-width: 767px) {
    margin: 12px 0;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 25px;
  margin-bottom: 25px;
  float: left;
  @media (max-width: 767px) {
    float: none;
    margin-top: 16px;
    margin-bottom: 16px;
    width: 100%;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

const Column = styled.div`
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  box-sizing: border-box;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

export default class AlertSetupView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allow_email_notifications: props.profile.allow_email_notifications,
      allow_sms_notifications: props.profile.allow_sms_notifications,
    };
  }

  submit = () => {
    const { editProfile } = this.props;

    editProfile(this.state);
  };

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  render() {
    const { allow_email_notifications, allow_sms_notifications } = this.state;

    return (
      <Container>
        <SettingsSectionTitle>Alerts</SettingsSectionTitle>
        <Row>
          <Column>
            <InputContainer>
              <Switch
                name="allow_email_notifications"
                isChecked={allow_email_notifications}
                titleChecked="Email notifications"
                titleUnchecked="Email notifications"
                onChange={this.handleChange}
              />
            </InputContainer>
          </Column>
        </Row>
        <Row>
          <Column>
            <InputContainer>
              <Switch
                name="allow_sms_notifications"
                isChecked={allow_sms_notifications}
                titleChecked="SMS notifications"
                titleUnchecked="SMS notifications"
                onChange={this.handleChange}
              />
            </InputContainer>
          </Column>
        </Row>
        <Row>
          <ButtonContainer>
            <ButtonText text="Save" theme="primary" onClick={this.submit} />
          </ButtonContainer>
        </Row>
      </Container>
    );
  }
}

AlertSetupView.propTypes = {
  editProfile: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
};
